import { render } from "./MenuCategory.vue?vue&type=template&id=5634e4b0&lang=pug"
import script from "./MenuCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuCategory.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__